import { Pipe, PipeTransform } from '@angular/core';
import {IDocumentTypesDto} from 'app/main/pages/documents/dto/document-listing.dto';

@Pipe({
  name: 'documentTypeSelectorFor'
})
export class DocumentTypeSelectorForPipe implements PipeTransform {

  transform(documentTypes: IDocumentTypesDto[], section: string) {
    let selectorFor = "";
    if(section == "document"){
      selectorFor = "1";
    } else if(section == "contract"){
      selectorFor = "2";
    }
    return documentTypes.filter(item => (
      item.id == null || item.id == 0 || item.selector_for == "3" || item.selector_for == selectorFor) 
    );  
  }
}